export function BotaoNovaVisita({ onClick }: { onClick: () => void }) {
  return (
    <button
      className="botao"
      onClick={onClick}
      style={{ display: "flex", alignItems: "center", gap: 8, padding: "11px 20px", fontSize: 15 }}
    >
      <span style={{ fontSize: 20, lineHeight: 1 }}>+</span> Nova Visita
    </button>
  );
}
